import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isWaitAudit,
// 判断当前员工是否有独自待审批节点任务
getInit,
// 离职原因,来源
editResign // 编辑离职
} from '@/api/org/staff';
export default {
  data: function data() {
    var self = this;
    return {
      // 账号自动注销
      isAutoLogOff: false,
      visible: false,
      dataForm: {
        leave_date: '',
        reason: '',
        remark: '',
        agree: false
      },
      staff_name: '',
      staff_id: '',
      formal_name: '',
      // 员工属性
      hire_date: '',
      // 入职日期
      dataRule: {
        leave_date: [{
          required: true,
          message: this.$t('1014')
        }],
        reason: [{
          required: true,
          message: this.$t('712')
        }],
        remark: [{
          required: true,
          message: this.$t('1999')
        }],
        agree: [{
          required: true,
          message: this.$t('17274_6b654577')
        }]
      },
      pickerOptions: {
        // 自动注销账号最大可选择操作当天
        disabledDate: function disabledDate(time) {
          if (self.isAutoLogOff) return time.getTime() < self.hire_date || time.getTime() > Date.now();
          return time.getTime() < self.hire_date;
        }
      },
      reasonArr: [] // 离职原因
    };
  },

  methods: {
    init: function init(item) {
      var _this = this;
      this.visible = true;
      this.$nextTick(function () {
        _this.$refs.dataForm.resetFields();
        _this.staff_name = item.staff_name;
        _this.formal_name = item.formal_name;
        _this.dataForm.leave_date = item.leave_date;
        _this.dataForm.reason = parseInt(item.leave_reason);
        _this.dataForm.remark = item.leave_reason_remarks;
        _this.dataForm.apply_source = item.apply_source;
        var isAutoLogOff = item.apply_source === '4';
        _this.isAutoLogOff = isAutoLogOff;
        _this.dataForm.agree = !isAutoLogOff;
        _this.staff_id = item.staff_id;
        _this.hire_date = new Date(item.hire_date).getTime();
      });
      getInit().then(function (res) {
        _this.reasonArr = res.data.reason.reason;
      });
    },
    addResign: function addResign() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return editResign(_objectSpread(_objectSpread({}, _this2.dataForm), {}, {
                staff_id: _this2.staff_id
              }));
            case 2:
              _this2.$emit('onSubmit');
              _this2.visible = false;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 编辑离职提交
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;
      this.$refs.dataForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(valid) {
          var day, _yield$isWaitAudit, data;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!valid) {
                  _context2.next = 11;
                  break;
                }
                // 如果所选“离职日期”为当日及以前，则该员工自动变为离职的同时，检查该员工当前是否有待审批任务，且该节点没有其他未离职的员工（在职/待离职/停职）
                day = _this3.$util.parseTime(new Date(), '{y}-{m}-{d}');
                if (!(_this3.dataForm.leave_date <= day)) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 5;
                return isWaitAudit({
                  staff_id: _this3.staff_id
                });
              case 5:
                _yield$isWaitAudit = _context2.sent;
                data = _yield$isWaitAudit.data;
                if (data) {
                  _this3.$confirm(_this3.$t('b2b876c0'), _this3.$t('229'), {
                    confirmButtonText: _this3.$t('131'),
                    cancelButtonText: _this3.$t('66'),
                    type: 'warning'
                  }).then(function () {
                    _this3.addResign();
                  }).catch(function () {});
                } else {
                  _this3.addResign();
                }
                _context2.next = 11;
                break;
              case 10:
                _this3.addResign();
              case 11:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};